import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const buyers = [{
  name: 'Carlos M.',
  city: 'Ciudad de México',
  time: 'hace 2 min'
}, {
  name: 'Valentina R.',
  city: 'Bogotá',
  time: 'hace 5 min'
}, {
  name: 'Andrés P.',
  city: 'Lima',
  time: 'hace 8 min'
}, {
  name: 'Sofía G.',
  city: 'Buenos Aires',
  time: 'hace 12 min'
}, {
  name: 'Diego L.',
  city: 'Madrid',
  time: 'hace 15 min'
}, {
  name: 'Camila T.',
  city: 'Santiago',
  time: 'hace 18 min'
}, {
  name: 'Javier H.',
  city: 'Medellín',
  time: 'hace 22 min'
}, {
  name: 'Lucía F.',
  city: 'Monterrey',
  time: 'hace 25 min'
}, {
  name: 'Mateo S.',
  city: 'Quito',
  time: 'hace 30 min'
}, {
  name: 'Isabella V.',
  city: 'Guadalajara',
  time: 'hace 33 min'
}, {
  name: 'Sebastián D.',
  city: 'Barcelona',
  time: 'hace 37 min'
}, {
  name: 'Mariana K.',
  city: 'Caracas',
  time: 'hace 40 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrentIndex(prev => (prev + 1) % buyers.length);
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  }, [dismissed]);
  useEffect(() => {
    // First popup after 8 seconds
    const initialTimer = setTimeout(() => {
      if (!dismissed) {
        setVisible(true);
        setTimeout(() => setVisible(false), 4000);
      }
    }, 8000);
    // Then every 40 seconds
    const interval = setInterval(showNext, 40000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [showNext, dismissed]);
  const buyer = buyers[currentIndex];
  if (dismissed) return null;
  return <AnimatePresence data-id="element-274">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-6 left-6 z-40 max-w-xs" data-id="element-275">
          <div className="bg-[#1a1a1a] border border-[#333] rounded-lg p-4 shadow-[0_0_30px_rgba(0,0,0,0.5)] flex items-start gap-3" data-id="element-276">
            <div className="w-10 h-10 rounded-full bg-[#14b8a6]/10 border border-[#14b8a6]/30 flex items-center justify-center shrink-0" data-id="element-277">
              <ShoppingBag size={18} className="text-[#14b8a6]" data-id="element-278" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-279">
              <p className="text-white text-sm font-semibold leading-tight" data-id="element-280">
                {buyer.name}
                <span className="text-gray-500 font-normal" data-id="element-281">
                  {' '}
                  de {buyer.city}
                </span>
              </p>
              <p className="text-[#14b8a6] text-xs font-medium mt-0.5" data-id="element-282">
                compró Ingresos Digitales Atómicos
              </p>
              <p className="text-gray-600 text-xs mt-1" data-id="element-283">{buyer.time}</p>
            </div>
            <button onClick={() => setDismissed(true)} className="text-gray-600 hover:text-gray-400 transition-colors shrink-0" aria-label="Cerrar" data-id="element-284">
              <X size={14} data-id="element-285" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}